/* eslint-disable */
import React from 'react'
// import { StyleSheet, TouchableOpacity } from 'react-native'
import { Text, View, Icon, Card } from '../../Components'
import { Metrics, Helpers, Colors,Spacing } from '../../global'

import {ReactComponent as cloudIcon} from '../../Assets/SVG/Cloud.svg'
import {ReactComponent as noCloudIcon} from '../../Assets/SVG/NoCloud.svg'
import {ReactComponent as dot} from '../../Assets/SVG/Dot.svg'

import {ReactComponent as usbIcon} from '../../Assets/SVG/USBPowered.svg'
import {ReactComponent as battery100Icon} from '../../Assets/SVG/Battery100.svg'
import {ReactComponent as battery80Icon} from '../../Assets/SVG/Battery80.svg'
import {ReactComponent as battery60Icon} from '../../Assets/SVG/Battery60.svg'
import {ReactComponent as battery40Icon} from '../../Assets/SVG/Battery40.svg'
import {ReactComponent as battery20Icon} from '../../Assets/SVG/Battery20.svg'
import {ReactComponent as battery10Icon} from '../../Assets/SVG/Battery10.svg'
import {ReactComponent as batteryLowIcon} from '../../Assets/SVG/BatteryLow.svg'
import {ReactComponent as teamIcon} from '../../Assets/SVG/TeamTool.svg'
import {ReactComponent as alertIcon} from '../../Assets/SVG/Alert.svg'

const styles = {
  container:{
    width: '100%',
    borderBottom:'2px solid',
    borderBottomColor: Colors.light,
  },
  headerContent: {
    display: 'inherit',
    flexDirection: 'row',
    alignItems: 'center',
    paddingBottom: 8,
    alignItems: 'flex-start',
    flex: 1,
    height: '100%',
    borderBottom:'2px solid',
    borderBottomColor: Colors.light,
    overflow:'hidden'
  },
  leftSymbolContainer: {
    display: 'flex',
    height:'100%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: Spacing.md
  },
  sharedIcon:{
    display:'flex',
    width: 20,
    height: 20,
    borderRadius: 20/2,
    zIndex: 2, // works on ios
    // elevation: 100, // works on android
    left:32,
    top:18,
    marginLeft:-25,
    marginRight:5,
    marginBottom:-20,
    // position: 'absolute',
    justifyContent:'center',
    alignItems:'center',
  },
  symbolContainer: {
    display: 'inherit',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottom:'2px solid',
    borderBottomColor: Colors.light,
    paddingRight:15
  },
  content: {
    flex: 0,
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
  region: {
    flex: 0,
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: '50%',
    alignItems: 'stretch',
  },
  valueRow: {
    ...Helpers.row,
    alignItems: 'flex-end',
  },
  overviewValue: {
    borderBottom:'2px solid',
    borderRightWidth:1,
    borderBottomColor: Colors.light,
    height:Spacing.compWidth,
    justifyContent: 'center',
    alignItems: 'center',
  },
  change: {
    marginLeft: 8,
  },
}

const Dashboard = ({ style, ...rest }) => (
  <View {...rest} style={{ ...styles.dashboard, ...style }} />
)

Dashboard.Content = ({ style, ...rest }) => {
  return <View {...rest} style={{ ...styles.content, ...style }} />
}

Dashboard.Region = ({ style, block, ...rest }) => {
  const regionStyle = { ...styles.region, ...style }

  if (block) {
    regionStyle.flexBasis = '100%'
  }

  return <View {...rest} style={regionStyle} padding="sm" />
}

Dashboard.Overview = ({
  style,
  title,
  description,
  onPress,
  symbol,
  usbPowered,
  cloudConnected,
  shared,
  sharer,
  children,
  alerts,
  batteryLvl,
  selected,
  ...rest
}) => {
  let hasAlert = alerts != null && Array.isArray(alerts) && alerts.length > 0
  let alertLength = 0
  if(hasAlert){
    alertLength = 0
    alerts.forEach(alert => {
      alertLength += alert.alertState.alertCnt
    });
  }
  return (
    <View onClick={onPress} style={{cursor:'pointer'}}>
      <View style={styles.container}>
        <Card
          as="container"
          style={{
            backgroundColor:selected?Colors.secondary20:'transparent',
            ...style,
            paddingRight: 0
          }}
        >
          <View style={{...Helpers.center,flexDirection:'row',display: 'flex',height:'50px'}}>
            {symbol && (
              <View style={{height:'100%',...Helpers.center}}>
              <View style={styles.leftSymbolContainer}>
                <Icon svg={symbol} size="md" />
              </View>
              {shared || sharer?<View style={styles.sharedIcon}>
                <Icon svg={shared?teamIcon:teamIcon} size="s20" />
              </View>:<></>}
              </View>
            )}
            <View style={{ ...styles.headerContent }}>
              <View style={{...Helpers.fillCol}}>
                <View>
                  <Text as="medium" color="darkGrey" weight="bold" >
                    {title ? title : ' '}
                  </Text>
                </View>
                <View>
                  <Text as="small" color="lightGrey">
                    {description ? description : ' '}
                  </Text>
                </View>
              </View>            
            </View>
            <View style={styles.symbolContainer}>
            {alertLength>0?<Icon svg={alertIcon} size="xs" color={Colors.error}/>:<></>}
            {usbPowered==undefined?<></>:usbPowered?<Icon size="xs" color={Colors.lightGrey} svg={usbIcon} />:
            <Icon svg={
              batteryLvl==100?battery100Icon:
              batteryLvl>=80?battery80Icon:
              batteryLvl>=60?battery60Icon:
              batteryLvl>=40?battery40Icon:
              batteryLvl>=20?battery20Icon:
              batteryLvl>=10?battery10Icon:
              batteryLowIcon
            } size='xs'/>}
            {cloudConnected?<Icon size="xs" color={Colors.lightGrey} svg={cloudIcon} />:<Icon size="xs" color={Colors.lightGrey} svg={noCloudIcon} />}
            </View>
          </View>
          {/* 62 is a "magic value" (icon width + padding) and CSS should be revisited to eliminate the need for it */}
          <View
            style={{
              marginLeft: 32,
              paddingLeft:Spacing.md,
            }}
          >
            {children}
            {/* {Array.isArray(children)
              ? children.map((child, i) => {
                  return React.cloneElement(child, {
                    key: `Dashboard-${i}`,
                    style: { width: '10%', ...Metrics.bottomPadding },
                  })
                })
              : children} */}
          </View>
        </Card>
      </View>
    </View>
  )
}

Dashboard.Value = ({ style, value, units, label, change, ...rest }) => {
  let fontSize = "xxlarge"
  //xlarge 7-9 large 10, medium 11, 12-13 small, 14-15 hint
  if(value.toString().length>=14){
    fontSize = "hint"
  } else if(value.toString().length>11){
    fontSize = "small"
  } else if(value.toString().length>10){
    fontSize = "medium"
  } else if(value.toString().length>9){
    fontSize = "large"
  } else if(value.toString().length>6){
    fontSize = "xlarge"
  } 
  return (
    <View style={style}>
      <View style={styles.valueRow}>
        <Text as={fontSize} color="darkGrey">{value + " " + units}</Text>
        {change && (
          <Text style={styles.change} as="xsmall" color={change > 0 ? 'positive' : 'error'}>
            {Math.abs(change).toString()}
            {units}
          </Text>
        )}
      </View>
      <Text as="small" color="lightGrey">
        {label}
      </Text>
    </View>
  )
}

Dashboard.OverviewValue = ({ style, value, units, label, live, low, high, avg, size,sensorType, icon, color, enabled, setEnabled,index, ...rest }) => {
  let enabledCount = 0
  // console.log("ENABLED:",enabled)
    enabled.forEach(attribute => {
        if(attribute)  enabledCount++
  })
  return (
    <View onClick={()=>{
      if(enabled){
        if(enabledCount==1 && enabled[index]){
          //Don't allow empty graph
        }else{
            let newEnabled = [...enabled]
            newEnabled[index] = !enabled[index]
            setEnabled(newEnabled)
        } 
      }
    }}>
    <View style={{...style,...styles.overviewValue,...Helpers.row}} sidePadding="xm">
      <View style={{...style,width:"50%",...Helpers.row,display:'flex',alignItems:'center'}} sidePadding="sm">
      <View style={styles.leftSymbolContainer}>
        <Icon svg={icon} size="xs" color={color}/>
      </View>
      <View>
        <View>
        <Text  as={size} color={live?"primary":"darkGrey"}>{value + " " + units}</Text>
        </View>
        {sensorType?
        <View style={Helpers.row}>
        <Text  as="small" color="secondary">{sensorType + " "}</Text>
        <Icon style={{alignSelf:'center'}} color= {Colors.lightGrey} svg={dot} size="xxxs" />
        <Text  as="small" color="lightGrey">
          {" " + label}
        </Text>
        </View>:
        <View>
        <Text  as="small" color="lightGrey">
          {label}
        </Text>
        </View>}
      </View>
      </View>
      <View style={{...Helpers.row,...Helpers.textCenter,width:"50%",alignSelf:'center'}}>
        <View style={{flex:1}}>
          <Text  style={Helpers.textCenter} as="small" color="darkGrey">{high}</Text>
        </View>
        <View style={{flex:1}}>
          <Text  style={Helpers.textCenter} as="small" color="darkGrey">{low}</Text>
        </View>
        <View style={{flex:1}}>
          <Text  style={Helpers.textCenter} as="small" color="darkGrey">{avg}</Text>
        </View>
      </View>
      
    </View>
    </View>
  )
}

Dashboard.Row = ({ style, icon, viewIcon, title, value, ...rest }) => {
  return (
    <View
      style={{
        flex: 0,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        {icon && <Icon svg={icon} size="sm" />}
        {viewIcon && viewIcon}
        <Text as="h4">{title}</Text>
      </View>
      {value && (
        <Text as="h4" style={{ alignSelf: 'flex-end' }}>
          {value}
        </Text>
      )}
    </View>
  )
}

export default Dashboard
